// CustomTheme.tsx

import React, { ReactNode } from "react";
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";

interface ThemeProviderProps {
  children: ReactNode;
}

const theme = createTheme({
  // Your theme configuration
  // For example:
  palette: {
    primary: {
      main: "#e78758", // Change to your desired primary color
    },
    secondary: {
      main: "#2c3e50", // Change to your desired secondary color
    },
  },
});

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
